import { render, staticRenderFns } from "./ForgotPasswordChangePwd.vue?vue&type=template&id=60798a9e"
import script from "./ForgotPasswordChangePwd.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordChangePwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports